var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',_vm._b({class:[
    _vm.progressType,
    {
      'is-narrow': _vm.progressStrokeWidth < 14
    }
  ],attrs:{"type":_vm.progressShape,"color":_vm.backgroundColorByType,"text-inside":_vm.isValueInside,"show-text":_vm.hasValue ? true : false,"width":_vm.progressDiameter,"stroke-width":_vm.progressStrokeWidth}},'el-progress',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }